module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/team_in_circle-97b43732ea5d51d52229d4a0307b78a7.png";